var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-container"},[_c('iframe',{attrs:{"src":_vm.src,"title":"WHEP Iframe Player","allow":"autoplay","allowfullscreen":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }